export const BRAND = {
  name: "Brainstem",
  suffix: "App Solutions",
  logoDark:
    "https://static.prod-images.emergentagent.com/jobs/e1da1474-423e-4b09-ab76-e66cc0019058/images/d1a01f283f95d49c254b0bd01a302daa0dfb6535d88be92a5cac0cad839db5d3.jpeg",
  logoLight:
    "https://static.prod-images.emergentagent.com/jobs/e1da1474-423e-4b09-ab76-e66cc0019058/images/4929be537f8b5874e70a80c544c3af22c225104c2446d908c6bb9095d6e1d56f.jpeg",
  founder: "Charles Rieder",
  founderRole: "Founder & Principal Systems Architect",
  phone: "705-209-1981",
  phoneDisplay: "+1 (705) 209-1981",
  phoneTel: "+17052091981",
  email: "info@brainstemappsolutions.com",
  location: "Ontario, Canada",
};

export const NAV_LINKS = [
  { id: "capabilities", label: "Capabilities" },
  { id: "portfolio", label: "Projects" },
  { id: "manifesto", label: "Manifesto" },
  { id: "founder", label: "Studio" },
  { id: "contact", label: "Contact" },
];

export const MARQUEE_ITEMS = [
  "iOS Native",
  "Android Core",
  "React Native",
  "Full-Stack Cloud",
  "Canadian Enterprise",
  "PlanFlow.pro",
  "EliteMechanical.solutions",
  "Flutter Architecture",
  "AI Synapses",
  "Progressive Web",
];

export const CAPABILITIES = [
  {
    tag: "01 / Native Mobile",
    title: "Native iOS & Android",
    desc: "Swift and Kotlin engineering built for buttery 120Hz performance, deep hardware access, and App Store / Play Store excellence.",
    stack: ["Swift", "Kotlin", "SwiftUI", "Jetpack"],
    span: "lg:col-span-3 lg:row-span-2",
    accent: "from-sky-500/20 to-indigo-600/10",
  },
  {
    tag: "02 / Cross-Platform",
    title: "React Native & Flutter",
    desc: "One codebase, both platforms, zero compromise on speed.",
    stack: ["React Native", "Flutter", "Expo"],
    span: "lg:col-span-3",
    accent: "from-indigo-500/20 to-purple-600/10",
  },
  {
    tag: "03 / Cloud Backends",
    title: "Enterprise Cloud & APIs",
    desc: "Scalable microservices, real-time sync, and rock-solid infrastructure.",
    stack: ["Node", "Python", "Postgres", "AWS"],
    span: "lg:col-span-3",
    accent: "from-purple-500/20 to-fuchsia-600/10",
  },
  {
    tag: "04 / Intelligence",
    title: "AI Synapse Integration",
    desc: "LLM pipelines, intelligent agents, and automation woven directly into your product.",
    stack: ["OpenAI", "RAG", "Agents"],
    span: "lg:col-span-3",
    accent: "from-cyan-500/20 to-blue-600/10",
  },
  {
    tag: "05 / Web Ecosystems",
    title: "Progressive Web Apps",
    desc: "Blazing-fast, installable web experiences that feel truly native.",
    stack: ["React", "Next", "PWA"],
    span: "lg:col-span-3",
    accent: "from-violet-500/20 to-indigo-600/10",
  },
];

export const PROJECTS = [
  {
    id: "planflow",
    name: "PlanFlow",
    domain: "planflow.pro",
    url: "https://planflow.pro",
    category: "Planning & Workflow Platform",
    desc: "A streamlined planning and workflow platform that helps teams organize, schedule, and ship work with clarity.",
    tags: ["Web App", "SaaS", "Productivity"],
    live: true,
  },
  {
    id: "elitemechanical",
    name: "Elite Mechanical",
    domain: "elitemechanical.solutions",
    url: "https://elitemechanical.solutions",
    category: "Field Logistics & Dispatch",
    desc: "A digital home for an industrial mechanical services company — service showcase, dispatch, and lead capture.",
    tags: ["Web", "Business", "Lead Gen"],
    live: true,
  },
  {
    id: "insync",
    name: "More In Progress",
    domain: "Under NDA",
    url: null,
    category: "Mobile • Cloud • AI",
    desc: "Several new builds are currently in active development across mobile and enterprise platforms. Yours could be next.",
    tags: ["iOS", "Android", "Cloud"],
    live: false,
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Architecture before pixels",
    desc: "We design future-proof schemas and zero-debt foundations before a single screen is drawn. Great apps are built on great structure.",
  },
  {
    no: "02",
    title: "Cross-platform parity",
    desc: "Fluid, native-grade performance on every device. iOS and Android get equal craft — never a second-class port.",
  },
  {
    no: "03",
    title: "Canadian craft, direct access",
    desc: "You talk directly to the founder. No junior account managers, no offshore telephone game — just clear, honest engineering.",
  },
  {
    no: "04",
    title: "Speed without compromise",
    desc: "From proof-of-concept to production in weeks, not quarters — with quality that holds up under real-world load.",
  },
];

export const PLATFORMS = ["iOS", "Android", "Web", "Cloud API", "AI"];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const scrollTop = () => {
  if (window.__lenis) window.__lenis.scrollTo(0);
  else window.scrollTo({ top: 0, behavior: "smooth" });
};
